import { useState, useEffect } from 'react';
import { getUserAuthData } from '../services/API';
import { addToClipBoard } from '../Helpers/helpers';
import { useSelector } from 'react-redux';
import QRCode from "react-qr-code";
import '../modal.css';
import ProgressBarComponent from '../Components/ProgressBarComponent';
import {
	pairHashpack,
	initConnection,
	disconnect,
	manualListener
} from '../Hashconnect';
import updateUserData from '../Redux/updateUser';
import updateWalletData from '../Redux/updateWallet';
import toast, { Toaster } from 'react-hot-toast';

import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';

function Header() {
	const [loading, setLoading] = useState(false);
	const [pairingString, setPairingString] = useState('');
	const [loadingMessage, setLoadingMessage] = useState("Loading ...");
	const [isConnectWindowOpen, setConnectWindowOpen] = useState(false);
	const [isConnecting, setIsConnecting] = useState(false);
	const userId = useSelector((state: any) => state.user.userId);
	const isFakeWallet = useSelector((state: any) => state.wallet.isFakeWallet)

	useEffect(() => {
			 getUserData();
	}, [ ]);

	async function closeFakeWalletModal() {
		updateWalletData(false)
	}

	async function getUserData() {
		try {
			setLoadingMessage("Fetching user data...")
			setLoading(true)
			let token: string | null = localStorage.getItem("accessToken");
			if (token) {
				const authData = await getUserAuthData(token);
				const id = authData.id;
				if (id) {
					updateUserData(id, authData, true)
				}
				setLoading(false)
				setLoadingMessage("Loading...")

			} else {
				setLoading(false)
				setLoadingMessage("Loading...")
			}
		} catch (error) {

		}
	}

	async function browserExtension() {
		try {
			setConnectWindowOpen(false);
			setIsConnecting(false)
			setLoadingMessage("Pairing...")
			setLoading(true)
			await pairHashpack();
			setLoading(false)
			setLoadingMessage("Loading...")
		} catch (error) {

		}
	}

	async function disconnectBrowserExtension() {
		try {
			setLoadingMessage("Disconnecting...")
			setLoading(true)
			await disconnect();
			updateUserData("", [], false)
			setLoading(false)
			setLoadingMessage("Loading...")
		} catch (error) {

		}
	}

	const openConnectWindow = () => {
		setConnectWindowOpen(true);
	};

	const closeConnectWindow = () => {
		setConnectWindowOpen(false);
		setIsConnecting(false)
	};

	async function startConnectionProcess() {
		setIsConnecting(true)
		const saveData: any = await initConnection()
		setPairingString(saveData.pairingString)
		manualListener(setLoading, setIsConnecting, setConnectWindowOpen)
	}
	
	function removeClassOnResize(className: string, minWidth: number) {
		window.addEventListener('resize', function() {
			if (window.innerWidth >= minWidth) {
				var elements = document.getElementsByClassName(className);
				for (var i = 0; i < elements.length; i++) {
					elements[i].classList.remove('show');
				}
			}
		});
	}
	removeClassOnResize('show', 1024);
	const notify = () => toast.success('Text Copied!');
	return (
		<>
			<header>
			<Navbar collapseOnSelect expand="lg" fixed="top"  data-bs-theme="dark">
				<Container>

			

					<Navbar.Brand href="/">
					<img
						src="/css/img-old/logo_RantCPU_white.png"
						width="auto"
						height="40"
						className="d-inline-block align-top"
						alt="RantCPU"
					/>
					</Navbar.Brand>
					<Navbar.Toggle aria-controls="responsive-navbar-nav" />
					<Navbar.Collapse id="responsive-navbar-nav">
					<Nav>
						<Nav.Link href="/#features">Home</Nav.Link>
						<Nav.Link href="/cardRedeem">Redeem Cards</Nav.Link>
						<Nav.Link href="/packRedeem">Claim  Packs</Nav.Link>
						{/* <Nav.Link href="#pricing">Contact</Nav.Link>
						<Nav.Link href="#pricing">One of One</Nav.Link>
						<Nav.Link href="#pricing">Tiers</Nav.Link> */}
					
						{userId ? (
							<button id="btnConnect" className="btnConnect" onClick={disconnectBrowserExtension}>Disconnect</button>
						) : (
							<button id="btnConnect" className="btnConnect" onClick={() => openConnectWindow()}>Connect</button>
						)
						}
					</Nav>
					</Navbar.Collapse>
				</Container>
				</Navbar>
				
			</header>

			{(loading === true) ?
				<ProgressBarComponent loadingMessage={loadingMessage} />
				:
				<></>
			}
			{(isConnectWindowOpen && !isConnecting) ?
				<div id="connectWindowContainer" className="connectWindowContainer">
					<div className="connectWindow">
						<span className="btnCloseContainer">Connect Wallet
							<div id="btnCloseWindow" className="btnCloseWindow" onClick={() => { closeConnectWindow() }}>
								<span className="material-symbols-outlined">close</span>
							</div>
						</span>
						<div className="btnWallets" id="btnHashpack" onClick={() => startConnectionProcess()}>
							<div>
								<div className="icon iconHashpack"></div>
								<span> Hashpack</span>
							</div>
							<span className="material-symbols-outlined">
								arrow_right_alt
							</span>
						</div>
						<span className="btnWallets cancel" onClick={() => { closeConnectWindow() }}>Cancel</span>
						<div className="rantCPU_04"></div>
					</div>
				</div>
				:
				(isConnecting) ?
					<div id="connectWindowContainer" className="connectWindowContainer">
						<div className="connectWindow open">
							<span className="btnCloseContainer">Connect Wallet
								<div id="btnCloseWindow" className="btnCloseWindow" onClick={() => { closeConnectWindow() }}>
									<span className="material-symbols-outlined">close</span>
								</div>
							</span>
							<div className='scan-container'>
								<h3 className='scan-text'>
									Scan the QR Code with your HashPack mobile app
								</h3>

								<QRCode className='qr' value={pairingString} />
								<button className="btn--secondary mb-2" onClick={() => { addToClipBoard(pairingString); notify() }}>Copy Pairing String</button>
								<Toaster  position="bottom-center" reverseOrder={false}/>
								<button className="btn--primary mb-2" onClick={browserExtension}>
									<span>Browser Extension</span>
								</button>
								<span className="btnWallets cancel" onClick={() => { closeConnectWindow() }}>Cancel</span>
							</div>
							<div className="rantCPU_04"></div>
							<br></br>
						</div>
					</div>
					:
					<></>
			}


			{(isFakeWallet) ?
				<div id="connectWindowContainer" className="connectWindowContainer">
					<div className="connectWindow">
						<span className='notification-icon02'>
							<svg xmlns="http://www.w3.org/2000/svg" width="72" height="72" viewBox="0 0 72 72"><g stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2"><path fill="#fcea2b" d="M32.522 13.005c.698-1.205 1.986-2.024 3.478-2.024c1.492 0 2.78.82 3.478 2.024L60.446 54.94A4 4 0 0 1 61 56.948a4.032 4.032 0 0 1-4.032 4.033l-41.936.017A4.033 4.033 0 0 1 11 56.966c0-.736.211-1.415.554-2.009l20.968-41.952" /><path fill="#FFF" d="M37.613 47.27a1.613 1.613 0 0 1-3.226 0V23.893a1.613 1.613 0 0 1 3.226 0v23.379z" /><circle cx="36" cy="54.529" r="1.613" fill="#FFF" /></g><g fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2"><path d="M32.522 13.005c.698-1.205 1.986-2.024 3.478-2.024c1.492 0 2.78.82 3.478 2.024L60.446 54.94A4 4 0 0 1 61 56.948a4.032 4.032 0 0 1-4.032 4.033l-41.936.017A4.033 4.033 0 0 1 11 56.966c0-.736.211-1.415.554-2.009l20.968-41.952" /><path d="M37.613 47.27a1.613 1.613 0 0 1-3.226 0V23.893a1.613 1.613 0 0 1 3.226 0v23.379z" /><circle cx="36" cy="54.529" r="1.613" /></g></svg>
						</span>
						<span className='notification-text qr'>This address does not exist on Hedera Network.<br></br>
							Please try To login with a different wallet address.</span>
						<span className="btnWallets ok" onClick={() => closeFakeWalletModal()}>OK</span>
						<div className="rantCPU_01"></div>
					</div>
				</div>
				:
				<></>
			}
		</>
	);
}

export default Header;